<template>
  <div>
    <div class="inst-title">다중 모델 검사</div>
    <pre class="inst-desc">
하나의 파일 안에 여러 개의 바디가 들어 있는 경우입니다.
하나의 부피 단위를 구성하는 바디가 여러 개 존재하게 되면 실시간 자동견적 산출 시
큰 모델로 인식이 되어 견적이 과도하게 산출되는 문제가 있을 수 있습니다.</pre
    >

    <div class="inst-subtitle">[해결방법]</div>

    <pre
      class="inst-desc"
    >· 캐드를 활용하여 설계 시 : 어셈블리 모델 전체를 내보내기(export) 하지 마시고, 파트별로 내보내기 하여 실시간 견적에 활용해 주세요.<br>· 메쉬 모델링 툴 사용 시 : 하나의 파일에 하나의 파트만 포함하도록 다시 모델링 파일을 구성하여 내보내기 해주세요.<br><div class="text-sm">※ 3D프린팅의 경우 : 의도적으로 비조립형 메커니즘(Non-assembly Mechanism)을 설계하는 경우가 있을 수 있습니다. 이 경우 해당 주의 사항은 무시하셔도 좋습니다.</div></pre>
  </div>
</template>

<script setup></script>
